const NAV_SIZE = {
  SMALL: 'small',
  LARGE: 'large',
};

module.exports = {
  NAV_SIZE,
};
